import React from 'react';
import { LinkProps } from 'react-router-dom';
import { CoreLinkProps, CoreLink } from 'app/components/core';
import { InAppLink } from '../InAppLink';

type UniversalLinkProps = LinkProps | CoreLinkProps;

const isLinkProps = (props: UniversalLinkProps): props is LinkProps => {
  return (props as LinkProps).to !== undefined;
};

export const UniversalLink: React.FC<UniversalLinkProps> = (props) => {
  if (isLinkProps(props)) {
    return <InAppLink {...props} />;
  }

  return <CoreLink {...props} />;
};
